import styled from 'styled-components'
import { Tabs } from 'antd'
import { P as PKS } from 'konsys-ui'

export const TabWrapper = styled(Tabs)`

`

export const TabPane = styled(Tabs.TabPane)`

`

export const P = styled(PKS)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export default TabWrapper
